import { Toast } from "vant";

export const mixins = {
  data() {
    return {
      urlList: [
        {
          url: "https://出现屏蔽替换此处.e5mtd.com/user.html?dc=985",
          icon: require("./../assets/png/app-nut.webp"),
          name: "nut",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.fj6rz.com/user.html?dc=985",
          icon: require("./../assets/png/app-hjll.webp"),
          name: "hjll",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.ub3t6.com/user.html?dc=985",
          icon: require("./../assets/png/app-haose.webp"),
          name: "haose",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.saxzg.com/user.html?dc=985",
          icon: require("./../assets/png/app-anwang.webp"),
          name: "anwang",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.r3ncm.com/user.html?dc=985",
          icon: require("./../assets/png/app-lieqi.webp"),
          name: "91lq",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.euwdu.com/user.html?dc=985",
          icon: require("./../assets/png/app-yjmh.webp"),
          name: "yjmh",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.zxa2b.com/user.html?dc=985",
          icon: require("./../assets/png/app-qysq.webp"),
          name: "qysq",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.4jf5x.com/user.html?dc=985",
          icon: require("./../assets/png/app-hls.webp"),
          name: "hls",
          time: 0,
        },
        {
          url: "https://中文可改成任意.sz1n9.com/user.html?dc=985",
          icon: require("./../assets/png/app-smtt.webp"),
          name: "smtt",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.4ixx1.com/user.html?dc=985",
          icon: require("./../assets/png/app-tiktok.webp"),
          name: "tiktok",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.xvxa3.com/user.html?dc=985",
          icon: require("./../assets/png/app-51ll.webp"),
          name: "51ll",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.slsxlas.com/user.html?dc=985",
          icon: require("./../assets/png/app-51bense.webp"),
          name: "51Bense",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.twz8s.com/user.html?dc=985",
          icon: require("./../assets/png/app-awjd.webp"),
          name: "awjd",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.adaxd.com/user.html?dc=985",
          icon: require("./../assets/png/app-paofu.webp"),
          name: "paofu",
          time: 0,
        },
        {
          url: "https://出现屏蔽替换此处.wsf6z.com/user.html?dc=985",
          icon: require("./../assets/png/app-sis.webp"),
          name: "sis",
          time: 0,
        },
      ], // 域名数组
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
